export const getEmployeeStatus = (status) => {
  switch (status) {
    case 1: return 'Retired';
    case 2: return 'Severance';
    case 3: return 'Withdrawn';
    case 4: return 'Parental Leave';
    case 5: return 'Leave';
    case 6: return 'Active';
    case 7: return 'Sick Leave';
    case 8: return 'Budget';
    case 9: return 'Study Leave';
    default: return 'None';
  }
};

export const getEmployeeGroup = (group) => {
  switch (group) {
    case 1: return 'Permanent';
    case 2: return 'Student';
    case 3: return 'Probation';
    case 4: return 'Summer Job';
    case 5: return 'Fixed Term';
    case 6: return 'External';
    case 7: return 'Hourly';
    case 8: return 'Work Contract';
    case 9: return 'Board Member';
    case 10: return 'Replacement';
    case 11: return 'Committees';
    default: return 'None';
  }
};



// WEBPACK FOOTER //
// ./src/utils/translations.js